/* eslint-disable react/prop-types */
import React from "react";
import assetify from "@quintype/framework/assetify";
import { CloseIcon } from "../podcast-player/icons";
import podcastImg from "../../../assets/images/nl-images/podcast-banner-on-homepage.png";
import { Button } from "../atoms/button";
import { Modal } from "../molecules/modal";

import "./floating-pod-button.m.css"

export function UsersOnlyNudge({ handleClose, redirectionUrl }) {

  const redirectToLogin = () => {
      window.location=redirectionUrl
  
  };

  return (
    <Modal onBackdropClick={handleClose} hideCloseIcon >
      <div styleName="wrapper">
      <img styleName="image" src={assetify(podcastImg)} alt="newslaundry logo" />
        <div styleName="btn">
          <button className="pressable" onClick={handleClose} style={{}}>
            <CloseIcon fill="#656565" width={18}></CloseIcon>
          </button>
        </div>
        <h5 styleName="headline">Oops! You need to login</h5>
        <p styleName="content">Register or login now to access our feature-laden podcast player for free</p>
        <div styleName="button">
          <Button style={{fontSize:"16px", textTransform:"capitalize", padding:"5px"}} className="nl-btn-inverse" onClick={redirectToLogin}>
            Register / Login
          </Button>
        </div>
      </div>
    </Modal>
  );
}
